"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const location_icon_black_svg_1 = __importDefault(require("../../assets/images/location-icon-black.svg"));
const search_icon_black_svg_1 = __importDefault(require("../../assets/images/search-icon-black.svg"));
const strings_1 = require("../../assets/strings/strings");
const Properties_1 = require("../../hooks/Properties");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const RangePickerComponent_1 = __importDefault(require("../rangePickerComponent/RangePickerComponent"));
require("./HeaderSearchForm.scss");
const SelectGuestComponent_1 = __importDefault(require("../formComponents/selectGuestComponent/SelectGuestComponent"));
const FacebookPixelLocation_1 = require("../facebookPixelLocation/FacebookPixelLocation");
const initialData = {
    selectField: null,
    selectField2: null,
    textField: '',
    numberField: 3,
    textAreaField: '',
    rangePickerField: [null, null],
};
const HeaderSearchForm = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const [form] = antd_1.Form.useForm();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [property, setProperty] = (0, react_1.useState)([]);
    const propContext = (0, Properties_1.useProperties)();
    const TransforPropertiesInContent = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield ((_a = propContext.properties) === null || _a === void 0 ? void 0 : _a.map(prop => {
            const newContent = {
                id: prop.propId,
                value: prop.name,
            };
            setProperty(oldContent => [...oldContent, newContent]);
        }));
    }), [propContext.properties]);
    (0, react_1.useEffect)(() => {
        TransforPropertiesInContent();
    }, [propContext, TransforPropertiesInContent]);
    const selectAllProperties = (0, react_1.useCallback)((values) => {
        const properties = values.map(prop => {
            return `"${prop.id.toString()}"`;
        });
        return properties;
    }, []);
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        const formValues = form.getFieldsValue();
        const propertyString = formValues.property
            ? `property=${JSON.stringify(formValues.property)}`
            : `property=[${selectAllProperties(property)}]`;
        let selectedDateString = '';
        const initialDate = form.getFieldValue('initialDate-range-header');
        const finalDate = form.getFieldValue('finalDate-range-header');
        const selectedDate = [initialDate, finalDate];
        if (initialDate || finalDate) {
            selectedDateString = `&selectedDate=${JSON.stringify(selectedDate)}`;
        }
        const baseName = 'selectQty';
        const qtyGuests = form.getFieldValue(`${baseName}Guests`);
        let qtyGuestsString = '';
        if (qtyGuests) {
            qtyGuestsString = `&guests=${qtyGuests}`;
        }
        const content_type = formValues.property
            ? JSON.stringify(formValues.property)
            : `[${selectAllProperties(property)}]`;
        (0, FacebookPixelLocation_1.sendFBPixel)('Search', {
            content_type,
            content_ids: '',
            city: 'São Paulo',
            region: 'São Paulo',
            country: 'BR',
            checkin_date: initialDate,
            checkout_date: finalDate,
        });
        history.push(`${RoutesPaths_1.routesPaths.bookSuite}?${propertyString}${selectedDateString}${qtyGuestsString}`);
    }), [form, history, property, selectAllProperties]);
    const dateTimeStringSP = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    const dateStringSP = dateTimeStringSP.split(' ')[0].split('/');
    const initialDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    const finalDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    finalDate.setFullYear(finalDate.getFullYear() + 1);
    finalDate.setDate(finalDate.getDate() - 1);
    const handleSelectAll = (0, react_1.useCallback)(value => {
        if (value && value.length && value.includes('all')) {
            if (value.length === property.length + 1) {
                form.setFieldsValue({ property: [] });
                return [];
            }
            form.setFieldsValue({ property: property.map(prop => prop.id) });
            return [...property];
        }
        return value;
    }, [form, property]);
    return (react_1.default.createElement("div", { className: "HeaderSearchForm" },
        react_1.default.createElement(antd_1.Spin, { tip: strings_1.HeaderSearchFormMessages.spinLoading, spinning: loading },
            react_1.default.createElement(antd_1.Form, { form: form, onFinish: handleSubmit, initialValues: initialData, labelAlign: "left", layout: "vertical", noValidate: true, className: "form-container" },
                react_1.default.createElement(RangePickerComponent_1.default, { form: form, name: "range-header", unavailableDates: [], initialDate: initialDate.toLocaleDateString('pt-BR'), finalDate: finalDate.toLocaleDateString('pt-BR') }),
                react_1.default.createElement(antd_1.Form.Item, { name: "property", className: "SelectComponent " },
                    react_1.default.createElement(antd_1.Select, { mode: "multiple", allowClear: true, suffixIcon: react_1.default.createElement("img", { src: search_icon_black_svg_1.default, alt: "", style: { width: 16, height: 25 } }), className: "SelectContent", onChange: handleSelectAll, placeholder: 
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("img", { src: location_icon_black_svg_1.default, alt: "", style: { width: 12 } }),
                            react_1.default.createElement("span", null, "Selecione uma localiza\u00E7\u00E3o")) },
                        react_1.default.createElement(antd_1.Select.Option, { className: "selectOption", value: "all", key: "all" },
                            react_1.default.createElement("img", { src: location_icon_black_svg_1.default, alt: "", style: { width: 12 } }),
                            react_1.default.createElement("span", null, "Selecionar todos")),
                        property.map(prop => (react_1.default.createElement(antd_1.Select.Option, { className: "selectOption", value: prop.id, key: prop.id },
                            react_1.default.createElement("img", { src: location_icon_black_svg_1.default, alt: "", style: { width: 12 } }),
                            react_1.default.createElement("span", null, prop.value)))))),
                react_1.default.createElement(SelectGuestComponent_1.default, { form: form, baseName: "selectQty", customClass: "SelectGuestComponent-home" }),
                react_1.default.createElement(antd_1.Button, { className: "search-button search-field", type: "primary", htmlType: "submit", loading: loading }, strings_1.HeaderSearchFormMessages.buttomSearch)))));
};
exports.default = HeaderSearchForm;
